/**
 * Status to colour. Copy lives in `@/strings/da`; this module only decides which tone a status
 * wears, so the banner, the pills and the rows cannot drift apart.
 */

import type { OverallStatus, TcpStatus, UdpStatus } from './status'
import type { Grade } from './calltest/grading'
import type { Verdict } from './calltest/types'

export type Tone = 'run' | 'ok' | 'warn' | 'fail'

export const TCP_TONE: Record<TcpStatus, Tone> = {
	pending: 'run',
	ok: 'ok',
	blocked: 'fail'
}

export const UDP_TONE: Record<UdpStatus, Tone> = {
	pending: 'run',
	ok: 'ok',
	symmetric: 'warn',
	'subnet-blocked': 'fail',
	'udp-blocked': 'fail'
}

export const OVERALL_TONE: Record<OverallStatus, Tone> = {
	run: 'run',
	ok: 'ok',
	warn: 'warn',
	fail: 'fail'
}

/** `NOT_MEASURED` is a warning, never a pass — an unjudged call has not been shown to work. */
export const VERDICT_TONE: Record<Verdict, Tone> = {
	OK: 'ok',
	DEGRADED: 'warn',
	NOT_MEASURED: 'warn',
	BAD: 'fail',
	NO_AUDIO: 'fail'
}

export const GRADE_TONE: Record<Grade, Tone> = {
	ok: 'ok',
	degraded: 'warn',
	bad: 'fail',
	unknown: 'run'
}
